import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Spinner } from 'ui/spinner';
import { pxToRem } from 'utils/convert';
import { InsightType } from '../domain';

const STYLED_HEIGHT: Record<InsightType, FlattenSimpleInterpolation> = {
  [InsightType.behavioral]: css({ minHeight: pxToRem(296) }),
  [InsightType.demographics]: css({ minHeight: pxToRem(600) }),
  [InsightType.listUsage]: css({ minHeight: pxToRem(372) }),
};

export const LoadingSection = styled(Spinner)<{ type: InsightType }>`
  display: flex;
  justify-content: center;
  grid-column: 1 / span 4;
  ${({ type }) => STYLED_HEIGHT[type]};
`;
